/* w9-tire-extras (2026-10-03, FIX-005)
   The tube and rim strip that go with a tire size. Shared by the tire finder (w9-tire-finder.js) and the
   tire product page block (sections/w9-tire-extras.liquid). Data: snippets/w9-tire-accessories.liquid,
   from the variant metafields tube.fits_tires and rim_strip.fits_rims. */
(function () {
  'use strict';
  if (window.w9TireExtras) return;

  /* ---------- matching (no DOM) ---------- */

  /* "110/90-19" -> {w:110,a:90,r:19}; "3.00-21", "21x2.75", "2.75-17" -> {wi:3,r:21}. Same rules as the finder. */
  function parseSize(s) {
    var t = String(s || '').toUpperCase().replace(/\s+/g, '');
    var m = t.match(/^(\d{2,3})\/(\d{2,3})[-R]?Z?R?(\d{2})/);
    if (m) return { w: +m[1], a: +m[2], r: +m[3] };
    m = t.match(/^(\d\.\d{1,2})-(\d{2})/);
    if (m) return { wi: +m[1], r: +m[2] };
    m = t.match(/^(\d{2})X(\d\.\d{1,2})/);
    if (m) return { wi: +m[2], r: +m[1] };
    return null;
  }

  function sameSize(a, b) {
    if (!a || !b || a.r !== b.r) return false;
    if (a.w && b.w) return a.w === b.w && a.a === b.a;
    if (a.wi && b.wi) return Math.abs(a.wi - b.wi) < 0.01;
    return false;
  }

  /* "21x1.60-1.85" -> {d:21, lo:1.6, hi:1.85} */
  function parseRange(s) {
    var m = String(s || '').replace(/\s+/g, '').match(/^(\d{2}(?:\.5)?)x(\d\.\d{1,2})-(\d\.\d{1,2})$/i);
    return m ? { d: +m[1], lo: +m[2], hi: +m[3] } : null;
  }

  function read(id) {
    var node = id && document.getElementById(id), d = null;
    try { d = JSON.parse(node.textContent); } catch (e) { d = null; }
    d = d || {};
    return {
      tubes: (d.tubes || []).map(function (t) {
        var m = String(t.t).match(/\d\.\d{2}-\d{2}/);
        t.size = m ? m[0] : t.t;
        t.label = 'Tube ' + t.size;
        t.sizes = (t.f || []).map(parseSize).filter(Boolean);
        return t;
      }),
      strips: (d.strips || []).map(function (s) {
        var m = String(s.t).match(/(\d{2})\s*mm/i);
        s.label = 'Rim strip ' + (m ? m[1] + ' mm' : s.t);
        s.ranges = (s.f || []).map(parseRange).filter(Boolean);
        return s;
      })
    };
  }

  /* The tube that takes this tire size (a size string or a parseSize result), or null. */
  function tubeFor(acc, size) {
    var want = typeof size === 'string' ? parseSize(size) : size;
    if (!want) return null;
    for (var i = 0; i < acc.tubes.length; i++) {
      if (acc.tubes[i].sizes.some(function (s) { return sameSize(s, want); })) return acc.tubes[i];
    }
    return null;
  }

  /* Strips for a rim diameter. Rim widths (e.g. ["2.15"]) narrow it to strips covering at least one of them. */
  function stripsFor(acc, rim, widths) {
    rim = +rim;
    widths = (widths || []).map(Number).filter(function (w) { return w > 0; });
    return acc.strips.filter(function (s) {
      return s.ranges.some(function (r) {
        return r.d === rim && (!widths.length || widths.some(function (w) { return w >= r.lo - 0.001 && w <= r.hi + 0.001; }));
      });
    });
  }

  /* Strips for a tire: by the rim width when it's known, else by the rims the size is listed for (tire.rim_fit).
     A size with no listed rims gets every strip for its diameter. */
  function stripsForTire(acc, rim, rimFit, rimW) {
    if (rimW) return stripsFor(acc, rim, [rimW]);
    var widths = (rimFit || []).map(function (l) { return String(l).split('x')[1]; }).filter(Boolean);
    return stripsFor(acc, rim, widths);
  }

  function stripRange(s, rim) {
    var r = s.ranges.filter(function (x) { return x.d === +rim; })[0];
    return r ? rim + '" rim, ' + r.lo.toFixed(2) + ' to ' + r.hi.toFixed(2) + ' wide' : '';
  }

  /* ---------- cart ---------- */

  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* Add one of each variant id in one request, then open the cart drawer (or go to the cart page). */
  function add(ids) {
    ids = ids.filter(Boolean).map(Number);
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || (j && j.status && j.status !== 200)) throw new Error((j && (j.description || j.message)) || 'This could not be added to your cart.');
        return j;
      });
    }).then(function (j) {
      var d = window.w9CartDrawer;
      if (d && d.refresh && d.open) {
        var p = d.refresh();
        return (p && p.then ? p : Promise.resolve()).then(function () { d.open(); return j; });
      }
      window.location.href = shopRoot() + 'cart';
      return j;
    });
  }

  /* Run add() from a button: busy state while it works, the error in msgEl if it fails. */
  function addFrom(btn, ids, msgEl) {
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; }
    add(ids).catch(function (e) {
      if (msgEl) { msgEl.textContent = e.message; msgEl.hidden = false; }
    }).then(function () { btn.disabled = false; btn.textContent = label; });
  }

  window.w9TireExtras = {
    parseSize: parseSize, sameSize: sameSize, parseRange: parseRange, read: read, tubeFor: tubeFor,
    stripsFor: stripsFor, stripsForTire: stripsForTire, stripRange: stripRange, add: add, addFrom: addFrom
  };

  /* ---------- product page block ---------- */

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function initProduct(root) {
    var vars = {};
    try { vars = JSON.parse(document.getElementById(root.getAttribute('data-variants')).textContent) || {}; } catch (e) { vars = {}; }
    var acc = read(root.getAttribute('data-acc'));
    var body = root.querySelector('[data-w9tx-body]');
    var sizeEl = root.querySelector('[data-w9tx-size]');
    var msg = root.querySelector('[data-w9tx-msg]');
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var shown = null;

    function currentId() {
      var input = form && form.querySelector('[name="id"]');
      var id = input && input.value;
      if (!id) { var m = window.location.search.match(/[?&]variant=(\d+)/); id = m && m[1]; }
      return String(id || root.getAttribute('data-first'));
    }

    function row(name, sub, price, control) {
      var r = el('div', 'w9tx__row');
      var what = el('div', 'w9tx__what');
      what.appendChild(el('span', 'w9tx__name', name));
      if (sub) what.appendChild(el('span', 'w9tx__subline', sub));
      r.appendChild(what);
      if (control) r.appendChild(control);
      var buy = el('div', 'w9tx__buy');
      if (price) buy.appendChild(el('span', 'w9tx__price', price));
      r.appendChild(buy);
      return { row: r, buy: buy };
    }

    function addButton(label, ids, aria) {
      var b = el('button', 'w9tx__add', label);
      b.type = 'button';
      if (aria) b.setAttribute('aria-label', aria);
      b.addEventListener('click', function () { addFrom(b, ids(), msg); });
      return b;
    }

    function render() {
      var id = currentId();
      if (id === shown) return;
      shown = id;
      var v = vars[id];
      body.innerHTML = '';
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      var tube = v ? tubeFor(acc, v.s) : null;
      var strips = v ? stripsForTire(acc, v.r, v.rf).filter(function (s) { return s.av; }) : [];
      /* Nothing we stock for this size: no block, rather than two "we don't stock" lines. */
      if (!v || (!tube && !strips.length)) { root.hidden = true; return; }
      root.hidden = false;
      var size = String(v.s || '').replace(/\s+(Front or rear|Front|Rear)$/i, '');
      if (sizeEl) sizeEl.textContent = size;

      var tubeId = null;
      if (tube) {
        var t = row(tube.label, 'Takes ' + (tube.f || []).join(', '), tube.pr);
        if (tube.av) {
          tubeId = tube.id;
          t.buy.appendChild(addButton('Add tube', function () { return [tube.id]; }, 'Add ' + tube.label + ' to cart'));
        } else {
          t.buy.appendChild(el('span', 'w9tx__out', 'Sold out'));
        }
        body.appendChild(t.row);
      } else {
        body.appendChild(el('p', 'w9tx__note', 'We don\'t stock a tube for ' + size + '.'));
      }

      var pickStrip = null;
      if (strips.length === 1) {
        var s1 = strips[0];
        var sr = row(s1.label, 'For ' + stripRange(s1, v.r), s1.pr);
        sr.buy.appendChild(addButton('Add strip', function () { return [s1.id]; }, 'Add ' + s1.label + ' to cart'));
        pickStrip = function () { return s1.id; };
        body.appendChild(sr.row);
      } else if (strips.length > 1) {
        var select = el('select', 'w9tx__select');
        select.setAttribute('aria-label', 'Rim strip for your rim width');
        strips.forEach(function (s) { select.appendChild(new Option(s.label + ' (' + stripRange(s, v.r) + ')', String(s.id))); });
        var mr = row('Rim strip', 'Pick your rim width', strips[0].pr, select);
        mr.buy.appendChild(addButton('Add strip', function () { return [select.value]; }));
        pickStrip = function () { return select.value; };
        body.appendChild(mr.row);
      } else if (v.r) {
        body.appendChild(el('p', 'w9tx__note', 'We don\'t stock a rim strip for this rim size.'));
      }

      if (tubeId && pickStrip) {
        var both = el('div', 'w9tx__both');
        both.appendChild(addButton('Add tube and strip', function () { return [tubeId, pickStrip()]; }));
        body.appendChild(both);
      }
    }

    function soon() { setTimeout(render, 0); setTimeout(render, 250); }
    document.addEventListener('change', soon);
    document.addEventListener('click', soon);
    window.addEventListener('popstate', soon);
    /* Some variant pickers set the hidden id without an event; a cheap check catches those. */
    setInterval(render, 800);
    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-w9tx]'), initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
